export const MOBILE_MIN = '(min-width: 0px)';
export const MOBILE_MAX = '(max-width: 768px)';
export const MOBILE_SCREEN = `${MOBILE_MIN} and ${MOBILE_MAX}`;
